function fixDate(d){
    if (!d || typeof d !== 'string') {
        console.warn('fixDate called with invalid date:', d);
        return new Date(); // Return current date as fallback
    }
    let t = d.split('-');
    return new Date(t[0], t[1]-1, t[2]);
}

module.exports = {
    fixDate
}